<div class="tt-c-reviews-list-utilities">
  <tt-reviews-list-toolbar v-if="showToolbar" @toggleSearch="toggleSearchField"></tt-reviews-list-toolbar>  
  <div v-show="appliedFilterOptions.length > 0 && !showSearchField" class="tt-c-reviews-list-utilities__applied-filters tt-u-spacing--left--xs">
    <tt-button v-for="filterOption in appliedFilterOptions" type="chip" class="tt-c-reviews-list-utilities__applied-filter" @click="removeFilter(filterOption.group, filterOption.filterName, filterOption.option)" :aria-label="$msg('reviewsList.removeFilter', [filterOption.optionTitle])"><span class="tt-c-reviews-list-utilities__applied-filter-text" v-html="filterOption.optionTitle"></span> <tt-icon name="close" size="xxs"></tt-icon></tt-button>
    <tt-button @click="clearAllFilters" type="compact-text" class="tt-c-reviews-list-utilities__applied-filters-clear" v-html="$msg('reviewsList.clearAll')"></tt-button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-list/reviews-list-utilities.html